import { createRoutine } from 'redux-saga-routines';

const NEWSLETTER_SUBSCRIBE_ACTION_PREFIX = 'NEWSLETTER_SUBSCRIBE_ACTION';
const newsletterSubscribeAction = createRoutine(NEWSLETTER_SUBSCRIBE_ACTION_PREFIX);

export { newsletterSubscribeAction };
